// Chinese Simplified
export const zh_CN = {
    weeklyRewards: '每周奖励还剩',
    days: '天',
    hours: '小时',
    minutes: '分钟',
    seconds: '秒',
    authenticating: '认证中',
    verifyWallet: '请等待我们验证您的钱包',
    authRequired: '需要认证',
    authFailed: '认证失败，请重试。',
    points: '积分',
    rank: '排名',
    of: '/',
    players: '玩家',
    weeklyTopPlayers: '本周顶尖玩家',
    thisWeekLeaderboard: '本周排行榜',
    rankingsReset: '排名将在每周日UTC午夜重置',
    yourPoints: '您的积分',
    dailyRewardAvailable: '每日奖励可领取！',
    nextClaimAvailable: '下次可领取时间：',
    claimDailyReward: '领取每日奖励',
    claiming: '领取中...',
    multiplier: '倍数',
    bonusPointsMultiplier: '奖励积分倍数',
    outOf: '/',
    loading: '加载中...',
    errorLoading: '加载错误',
    noEntries: '暂无记录',
    leaderboard: '排行榜',
    tasks: '任务',
    rules: '规则',
    profile: '个人资料',
    comingSoon: '即将推出...',
    completedTasks: '已完成任务',
    dailyRewardsClaimed: '已领取每日奖励',
    times: '次',
    recentActivity: '最近活动',
    noRewardsClaimed: '尚未领取任何奖励',
    dailyReward: '每日奖励',
    howItWorks: '如何运作',
    welcomeMessage: '欢迎来到Coinomi奖励！完成各种任务赚取积分，攀登排行榜。',
    dailyRewardsTitle: '每日奖励',
    dailyRewardsRules: [
        '每24小时领取一次每日奖励',
        '每次领取可获得100积分',
        '积分将根据您的倍数倍增',
    ],
    multiplierBonusesTitle: '倍数奖励',
    multiplierBonusesRules: [
        '从1倍开始',
        '连接Telegram获得+10%奖励',
        '验证邮箱获得+10%奖励',
        '奖励可叠加以获得最大收益',
    ],
    leaderboardTitle: '排行榜',
    leaderboardRules: ['与其他玩家竞争', '实时更新排名', '顶尖玩家获得特殊奖励'],
    boostEarningsTitle: '提升收益',
    boostEarningsRules: ['完成挑战获得奖励', '加入我们的Telegram社区', '保持活跃以最大化您的奖励'],
    challenges: '挑战',
    telegramChallenge: 'Telegram挑战',
    emailChallenge: '邮箱挑战',
    connectTelegram: '连接Telegram',
    shareEmail: '分享邮箱',
    telegramSuccess: '🎉 恭喜！您现在获得所有奖励的永久10%加成！',
    telegramPrompt: '连接您的Telegram账号获得所有奖励的永久10%加成！',
    emailSuccess: '🎉 恭喜！您现在获得所有奖励的永久10%加成！',
    emailPrompt: '分享您的邮箱获得所有奖励的永久10%加成！',
    connectEmail: '连接邮箱',
    cancel: '取消',
    emailPrivacy: '我们只会使用您的邮箱发送重要更新和奖励通知。',
    connectYourEmail: '连接您的邮箱',
    emailBonus: '🎉 连接邮箱获得所有奖励的永久10%加成！',
    enterValidEmail: '请输入有效的邮箱地址',
    emailAddress: '邮箱地址',
    errorSavingEmail: '保存邮箱时出错。请重试。',
    claimButton: '领取',
    earnedReward: '获得奖励',
    rewardValue: '{{amount}}积分',
    claimingReward: '领取中...',
    claimSuccess: '成功领取{{amount}}积分！',
    claimError: '领取奖励失败。请重试。',
    privacyDisclaimer: 'Coinomi不收集个人数据；第三方系统安全管理积分和社交连接。',
    streakBonus: '连续奖励',
    streakDays: '{{days}}/5天',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10%额外',
    streakDescription: '连续5天领取获得最大奖励',
    streakToday: '今天',
    streakMissed: '错过',
    streakComplete: '完成',
    streakActive: '连续中',
    streakLost: '连续中断',
    streakNext: '下一个',
    home: '首页',
    currentStreak: '当前连续',
    totalClaims: '总领取次数',
    userStats: '您的统计',
    referrals: '推荐',
    referralProgram: '推荐计划',
    howReferralWorks: '推荐如何运作：',
    referralSteps: [
        '与朋友分享您的推荐链接',
        '当他们使用您的链接加入时，他们成为您的推荐',
        '每个活跃推荐都能获得奖励积分',
        '在这里追踪您的推荐和收益',
    ],
    referralRewards: '推荐积分奖励：',
    referralBonuses: ['推荐一人获得100积分', '获得被推荐人10%的积分奖励'],
    yourReferralLink: '您的推荐链接',
    copyToClipboard: '复制到剪贴板',
    linkCopied: '链接已复制到剪贴板！',
    totalReferrals: '总推荐数',
    yourReferralCode: '您的推荐码',
    referralCodeCopied: '推荐码已复制！',
    editReferralCode: '编辑推荐码',
    editReferralCodeInstructions: '选择新的推荐码。必须至少5个字符，可包含字母和数字。',
    newReferralCode: '新推荐码',
    referralCodeRequirements: '最少5个字符，仅限字母和数字',
    updating: '更新中...',
    update: '更新',
    referralCodeTaken: '此推荐码已被使用',
    haveReferralCode: '有推荐码？',
    enterReferralCodePrompt: '如果有人推荐您，在此输入他们的推荐码以连接账户。',
    enterReferralCode: '输入推荐码',
    enterReferralCodeInstructions: '输入分享给您的推荐码。',
    referralCode: '推荐码',
    referralCodeFormat: '仅限字母和数字',
    submitting: '提交中...',
    submit: '提交',
    enterCode: '输入代码',
    pleaseAddtoken: '请在URL中添加token参数',
    authenticationError: '认证过程中发生错误',
    noUserFound: '未找到用户',
    userNotFoundMessage: '无法找到用户数据',
    backToHome: '返回首页',
    retry: '重试',
    baseMultiplier: '基础倍数',
    telegramBonus: 'Telegram奖励',
    referralChallenge: '推荐挑战',
    referralChallengePrompt: '邀请朋友赚取奖励积分！每推荐一人获得100积分，外加他们收益的10%！',
    startReferring: '开始推荐',
    referralSuccess: '🎉 恭喜！您已成功推荐用户并正在赚取奖励积分！',
    unranked: '未排名',
    noPlayersYet: '成为第一个加入的玩家！',
    shareVia: '分享方式',
    shareOn: '分享到{{network}}',
    shareInviteText:
        '🚀 我正在用@CoinomiWallet赚取免费加密货币！\n\n在coinomi.com/downloads下载Coinomi，在应用中加入#Coinomi Rewards时输入我的推荐码{{referralCode}}即可获得奖励。',
    // Twitter Challenge
    twitterChallenge: 'Twitter挑战',
    connectTwitter: '连接Twitter',
    twitterSuccess: '🎉 恭喜！您现在获得所有奖励的10%永久加成！',
    twitterPrompt: '关联您的Twitter账号，获得所有奖励的10%永久加成！',
    pleaseAddUserId: '请在URL中添加userId参数',
    emailChallengePrompt: '分享您的邮箱获得所有奖励的永久10%加成！',
    emailChallengeSuccess: '🎉 已连接！您现在获得所有奖励的永久10%加成！',
    followKoalaWalletChallenge: '请在Twitter上关注@coinomiWallet支持我们！',
    twitterAuthSuccessTitle: 'Twitter已成功连接！',
    twitterAuthSuccessMessage: 'Twitter账号已成功连接。您现在可以继续使用应用。',
    continueToApp: '继续进入应用',
    twitter_like: '已点赞推文',
    twitter_retweet: '已转发推文',
    disconnect: '断开连接',
    followCoinomiWallet: '在Twitter上关注@coinomiWallet支持我们！',
    connectedBonus: '🎉 已连接！您现在获得所有奖励的永久10%加成！',
};
